import React, { useState } from "react";
import Pagination from "./Pagination";
import { useDeleteResquedAmountMutation, useGetTopUPQuery } from "../apis/TopUPApi";
import { getUserData } from "../auth";
import { AiOutlineDelete } from "react-icons/ai";

const TopupRequestedList = () => {
  const [statusFilter, setStatusFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
 
  const userData = getUserData();
  const userId = userData?.uid || ""; 

  // Fetch data with RTK Query
  //const { data: walletRequests = [], error, isLoading } = useGetTopUPQuery(userId);
  const { data: sortedCarts = [], error, isLoading } = useGetTopUPQuery(userId, { pollingInterval: 5000 });

   const [deleteRequest, { isLoading: isDeleting, isSuccess, isError, error: deleteError }] = useDeleteResquedAmountMutation();

   const walletRequests  = sortedCarts? [...sortedCarts].sort((a, b) => b.id - a.id) : [];

  // Filter data based on status and validation date
  const filteredRequests = walletRequests.filter((request) => {
    const isStatusMatch = statusFilter ? request.status === statusFilter : true;
    const isDateMatch = dateFilter
      ? new Date(request.date).toLocaleDateString() === new Date(dateFilter).toLocaleDateString()
      : true;
    return isStatusMatch && isDateMatch;
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  // Paginate data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRequests = filteredRequests.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Delete a request with confirmation
  const handleDelete = async (requestId) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this request?");
    if (!isConfirmed) {
      return; // If user cancels, don't proceed with deletion
    }

 
    try {
      await deleteRequest(requestId);  // Assuming deleteRequest is the function from RTK Query
      alert("Request deleted successfully!");
    } catch (error) {
      console.error("Error deleting request:", error);
     } finally {
     }
  };

  return (
    <section className="cart py-15">
      <div className="container container-lg">
        <div className="row gy-4">
        <div className='col-lg-11'>
        {/* Filters */}
            <div className="filters mb-4">
              <label>
                Status:
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="ms-2"
                >
                  <option value="">All</option>
                  <option value="PENDING">PENDING</option>
                  <option value="APPROVED">APPROVED</option>
                </select>
              </label>

              <label className="ms-4">
                Validation Date:
                <input
                  type="date"
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                  className="ms-2"
                />
              </label>
            </div>

            {/* Loading or Error State */}
            {isLoading && <div>Loading...</div>}
            {error && <div>Error fetching data</div>}

            {/* Delete Error */}
            {deleteError && (
              <div className="alert alert-danger" role="alert">
                {deleteError}
              </div>
            )}

            {isDeleting && <div>Deleting...</div>}
            {isError && <div>Error deleting Resquest: {deleteError.message}</div>}
            {isSuccess && <div>Resquest deleted successfully!</div>}
            {/* Table */}
            <div className="cart-table border border-gray-100 rounded-8 px-20 py-48">
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                <table className="table style-three">
                  <thead>
                    <tr>
                       <th className="h6 mb-0 text-lg fw-bold">Amount</th>
                       <th className="h6 mb-0 text-lg fw-bold">Currency</th>
                      <th className="h6 mb-0 text-lg fw-bold">Status</th>
                      <th className="h6 mb-0 text-lg fw-bold">Requested Date</th>
                      <th className="h6 mb-0 text-lg fw-bold">Validated</th>
                      <th className="h6 mb-0 text-lg fw-bold">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRequests.length > 0 ? (
                      currentRequests.map((request) => (
                        <tr key={request.id}> 
                          <td>{request.amountRequested}</td>
                          <td>{request.name}</td>

                          <td>
                            <span
                              className={`badge ${
                                request.status === "PENDING"
                                  ? "bg-warning"
                                  : request.status === "APPROVED"
                                  ? "bg-success"
                                  : "bg-secondary"
                              }`}
                            >
                              {request.status || "N/A"}
                            </span>
                          </td>

                          <td>{new Date(request.date).toLocaleDateString()}</td>

                          <td>
                            {request.validateDateTime ? (
                               request.validateDateTime 
                            ) : (
                              <span className="badge bg-warning">Pending</span>
                            )}
                          </td>

                          <td>
                            
                          {request.validateDateTime ? (
                              "No Action"
                            ) : (
                              <AiOutlineDelete
                                onClick={() => handleDelete(request.id)}
                                className="text-danger cursor-pointer"
                                size={24}
                              />
                            )}

                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No wallet requests found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pagination Component */}
      <Pagination
        totalItems={filteredRequests.length}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
      />
    </section>
  );
};

export default TopupRequestedList;
